import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { linksRouter } from "../../../config/RouterLink";
import { Link } from "react-router-dom";

/**Ant-design components*/
import {
  Card,
  Row,
  Col,
  Typography,
  Button,
  Checkbox,
  Modal,
  Form,
  Select,
  Empty,
  Spin,
  Divider,
  notification,
} from "antd";

/**Ant-design icons */
import { InfoCircleFilled, LoadingOutlined } from "@ant-design/icons";

/**Redux-Ducks */
import { obtenerEstado } from "../../../redux/consultavacantes/cestadoDucks";
import { obtenerConcursos } from "../../../redux/consultavacantes/sistemasDucks";
import { BanderaPostula } from "../../../redux/consultavacantes/sistemasDucks";
import {
  PerfilesINE,
  PerfilesOPLE,
} from "../../../redux/consultavacantes/descripcionpuestoDucks";
import { getUltimoProtestoAceptadoTAspProtes } from "../../../redux/aspirante/TipoAspiranteProtestoDuck";

/**Utils */
import * as uiText from "../../../utils";
import {
  cleanStatePostulaciones,
  setPostulacion,
  obtenerPostulacion,
  cleanResultadoProceso,
} from "../../../redux/postulaciones/postulacionesDucks";

import "./ContenidoVacantes.css";

const { Paragraph, Text } = Typography;
const { Option } = Select;

export const ContenidoVacantes = () => {
  const { autenticado, idAspirante, correo, nombre, apellidos } = useSelector(
    (state) => state.usuarioLogin
  );
  const {
    objetivos,
    funciones,
    requisitos,
    objetivoINE,
    funcionesINE,
    requisitosINE,
    perfilesINE,
    perfilesOPLE,
  } = useSelector((state) => state.descripcionPuesto);

  const { idSistema, idConcurso, idConvocatoria, vacanteDetalle } = useSelector(
    (state) => state.consultaVacantes
  );
  //const { bandera } = useSelector((state) => state.sistemas);
  const { concursos } = useSelector((state) => state.sistemas);
  const { estados } = useSelector((state) => state.cestados);
  const {
    informacion,
    resultadoProceso,
    btnbandera,
    sistemaBand,
    resultadoFinal,
  } = useSelector((state) => state.postulacion);

  const { ultimoProtestoAceptado } = useSelector(
    (state) => state.tipoAspiranteProtestoStore
  );

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalExamen, setIsModalExamen] = useState(false);
  const [isModalVacante, setIsModalVacante] = useState(false);
  const [checked, setChecked] = useState(false);
  const [checkedVacante, setCheckedVacnte] = useState(false);
  const [btndesactiva, setbtndesactiva] = useState(true);
  const [btndesactivaVacante, setbtndesactivaVacante] = useState(true);
  const [cargandoInfo, setCargandoInfo] = useState(false);
  //const [btnpostula, setbtnpostula] = useState(true);

  const dispatch = useDispatch();
  const history = useHistory();

  const handleChange = (value) => {
    selectEntidad(value);
    let estadoSeleccionado;
    for (let index = 0; index < estados.length; index++) {
      if (estados[index].idEstado === value) {
        estadoSeleccionado = estados[index].nombreEstado;
      }
    }
    localStorage.setItem("estado", estadoSeleccionado);
  };
  const estadoExamen = localStorage.getItem("estado");

  /** Para mostrar/ocultar el botón continuar */
  const habilitarcheck = (e) => {
    setChecked(e.target.checked);
    setbtndesactiva(!btndesactiva);
  };

  /** Para mostrar/ocultar el botón continuar checked vacante*/
  const habilitarcheckVacante = (e) => {
    setCheckedVacnte(e.target.checked);
    setbtndesactivaVacante(!btndesactivaVacante);
  };

  const onClick = () => {
    let dataPostulacion = {
      idTipoConcurso: concursos.idTipoConcurso,
      idSistema: idSistema,
      idAspirante: idAspirante,
      idConcurso: idConcurso,
      idConvocatoria: idConvocatoria,
      idEstadoExamen: entidad,
      idEstatusProceso: null, //bandera.valorConfiguracion === "1" ? bandera.valorConfiguracion : "2",
      idMotivoDescarte: null, //bandera.valorConfiguracion === "1" ? null : 1,
      idTipoCargoPuesto: vacanteDetalle.idTipoCargoPuesto,
      idCargoPuesto: idSistema === 2 ? vacanteDetalle.idCargoPuesto : null,
      fhConfirma: null,
      usuarioConfirma: null,
      idTipoConfirma: null,
      estatus: 1,
      usuario: correo,
      nombresApellidos: nombre + " " + apellidos,
      denominacion: vacanteDetalle.denominacion,
      nombretipo: vacanteDetalle.nombretipo,
      estado: estadoExamen,
      nombreestado: vacanteDetalle.nombreestado,
    };

    let dataHistorial = {
      idAspirante: idAspirante,
      idConcurso: idConcurso,
      idConvocatoria: idConvocatoria,
      idTipoCargoPuesto: vacanteDetalle.idTipoCargoPuesto,
      idCargoPuesto: idSistema === 2 ? vacanteDetalle.idCargoPuesto : null,
    };
    setCargandoInfo(true);
    dispatch(setPostulacion(dataPostulacion, dataHistorial)).then(() => {
      setCargandoInfo(false);
    });
  };

  const openNotification = (placement) => {
    notification.info({
      message: <Text style={{ fontSize: "20px", fontWeight: 700 }}>Aviso</Text>,
      description: (
        <Text style={{ fontSize: "16px" }}>
          <br />
          Se identificó que no tiene capturado el tipo de aspirante y protesto
          para esta convocatoria.
          <br />
          Favor de registrar y aceptar para seguir con el proceso de
          postulación.
        </Text>
      ),

      placement,
      duration: 10,
      top: 50,
      className: "notificationInfo",
    });
  };

  const validaProtesto = () => {
    if (ultimoProtestoAceptado === false) {
      openNotification("top");
      setIsModalVacante(false);
    } else {
      openOrCloseModalVacante(true);
    }
  };

  useEffect(() => {
    dispatch(getUltimoProtestoAceptadoTAspProtes(idAspirante));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idAspirante]);

  useEffect(
    () => {
      if (resultadoProceso === 1) {
        history.push(linksRouter.aprobada);
        dispatch(cleanStatePostulaciones());
        dispatch(cleanResultadoProceso());
      }
      if (resultadoProceso === 2) {
        history.push(linksRouter.declinada);
        dispatch(cleanStatePostulaciones());
        dispatch(cleanResultadoProceso());
      }
      if (informacion.isError) {
        alert("error al guardar");
        dispatch(cleanStatePostulaciones());
        dispatch(cleanResultadoProceso());
      }
    },
    // eslint-disable-next-line
    [resultadoProceso]
  );

  useEffect(() => {
    if (idSistema === 1 && requisitosINE.length > 0) {
      localStorage.setItem(
        "experienciaine",
        requisitosINE[0].tiempoExperiencia
      );
    }
    if (idSistema === 2 && requisitos.length > 0) {
      localStorage.setItem("experienciaople", requisitos[0].tiempoExperiencia);
    }
    // eslint-disable-next-line
  }, [requisitos, requisitosINE]);

  useEffect(() => {
    dispatch(BanderaPostula());
    dispatch(obtenerPostulacion());
    dispatch(PerfilesINE());
    dispatch(PerfilesOPLE());
  }, [dispatch]);

  useEffect(() => {
    dispatch(obtenerConcursos(idSistema));
    // eslint-disable-next-line
  }, [idSistema]);

  const openOrCloseModalVacante = () => {
    setIsModalVacante((state) => !state);
    setCheckedVacnte(false);
    setbtndesactivaVacante(true);
  };

  const ModalVacante = () => (
    <Modal
      title={
        <h3>
          <b>IMPORTANTE</b>
        </h3>
      }
      visible={isModalVacante}
      onCancel={openOrCloseModalVacante}
      keyboard={false}
      maskClosable={false}
      width={500}
      footer={null}
    >
      <Card className="card-vacantes-list">
        <Paragraph>
          <Text
            style={{
              fontSize: 18,
              fontWeight: 400,
              color: "#333333",
            }}
          >
            <center>
              <b>¿Deseas continuar con la postulación del cargo/ puesto?</b>
              <br />
              <br />
              {idSistema === 1 && <>{vacanteDetalle.nombretipo}</>}
              {idSistema === 2 && <>{vacanteDetalle.denominacion}</>}
              <br />
              <br />
            </center>
          </Text>
        </Paragraph>
        <center>
          <Card style={{ backgroundColor: "#ffc0e9" }}>
            <Checkbox checked={checkedVacante} onChange={habilitarcheckVacante}>
              <Text
                style={{
                  fontSize: 18,
                  fontWeight: 700,
                  color: "#333333",
                  textAlign: "justify",
                }}
              >
                Si, quiero continuar.
              </Text>
            </Checkbox>
          </Card>
        </center>
        <center>
          <Button
            style={{
              marginTop: "20px",
              align: "center",
              width: "30%",
            }}
            type="primary"
            htmlType="submit"
            disabled={btndesactivaVacante}
            onClick={openOrCloseModalImportante}
          >
            Continuar
          </Button>
        </center>
      </Card>
    </Modal>
  );

  /** Para mostrar/ocultar el modal del idSistema 1 */
  const openOrCloseModalImportante = () => {
    setIsModalVisible((state) => !state);
    setIsModalVacante(false);
    setChecked(false);
    setbtndesactiva(true);
  };

  const ModalImportante = () => (
    <Modal
      title={
        <h3>
          <b>IMPORTANTE</b>
        </h3>
      }
      visible={isModalVisible}
      onCancel={openOrCloseModalImportante}
      keyboard={false}
      maskClosable={false}
      width={500}
      footer={null}
    >
      <Card className="card-vacantes-list">
        <Paragraph>
          <Text
            style={{
              fontSize: 16,
              fontWeight: 400,
              color: "#333333",
              textAlign: "justify",
            }}
          >
            Te recordamos que al postularte, ya no podrás modificar la
            información personal, académica y laboral que capturaste.
            <br />
            <br />
            <b>
              Si necesitas hacer cambios a tu información, realízalos antes de
              continuar.
            </b>
            <br />
          </Text>
        </Paragraph>
        <center>
          <Card style={{ backgroundColor: "#ffc0e9" }}>
            <Checkbox checked={checked} onChange={habilitarcheck}>
              <Text
                style={{
                  fontSize: 16,
                  fontWeight: 700,
                  color: "#333333",
                  textAlign: "justify",
                }}
              >
                Lo entiendo, quiero continuar.
              </Text>
            </Checkbox>
          </Card>
        </center>
        <center>
          <Button
            style={{
              marginTop: "20px",
              align: "center",
              width: "30%",
            }}
            type="primary"
            htmlType="submit"
            // disabled={true}
            disabled={btndesactiva}
            onClick={openOrCloseModalExamen}
          >
            Continuar
          </Button>
        </center>
      </Card>
    </Modal>
  );

  /**
   * Para mostrar/ocultar el modal examen idSistema 2
   */
  const openOrCloseModalExamen = () => {
    setIsModalVisible(false);
    setIsModalExamen((state) => !state);
  };

  const ModalExamen = () => (
    <Modal
      visible={isModalExamen}
      onCancel={openOrCloseModalExamen}
      keyboard={false}
      maskClosable={false}
      width={450}
      footer={false}
    >
      <Divider />
      <div className="">
        <Spin
          spinning={cargandoInfo}
          size="large"
          indicator={
            <LoadingOutlined style={{ fontSize: 80, color: "#9254de" }} spin />
          }
          tip="Cargando..."
          style={{ fontSize: 20, color: "#9254de" }}
        >
          <div
            id="scrollableDiv"
            style={{
              height: 500,
              width: 400,
              overflow: "auto",
              padding: "0 16px",
              border: "1px solid rgba(140, 140, 140, 0.35)",
            }}
          >
            <div className="alert-info">
              <InfoCircleFilled
                style={{ color: "#91d5ff", fontSize: "18px" }}
              />
              <Text
                style={{
                  fontSize: 18,
                  fontWeight: 700,
                  color: "#333333",
                  textAlign: "justify",
                }}
              >
                IMPORTANTE
              </Text>
              <br />
              {uiText.INFO_VACANTE_EXAM}
            </div>
            <Col span={8} xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
              <Form.Item>
                <Text
                  style={{
                    fontSize: 16,
                    fontWeight: 400,
                    color: "#333333",
                    name: entidad,
                  }}
                >
                  Estado
                </Text>

                <br />
                <center>
                  <Select
                    showSearch
                    style={{ width: 368 }}
                    placeholder="Seleccione una opción"
                    allowClear
                    value={entidad}
                    onChange={(value) => {
                      handleChange(value);
                    }}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {estados !== undefined &&
                      estados.map((item, index) => (
                        <Option key={index} value={item.idEstado}>
                          {item.nombreEstado}
                        </Option>
                      ))}
                  </Select>
                </center>
              </Form.Item>
            </Col>
          </div>
          <br />
          <center>
            <Button
              className="btn-guardar"
              type="default"
              htmlType="submit"
              onClick={onClick}
              disabled={entidad === undefined || entidad === null}
            >
              Guardar
            </Button>
          </center>
        </Spin>
      </div>
    </Modal>
  );

  /**
   * Función que controla la elección del Estado
   *
   */

  const [entidad, setEntidad] = useState(null);
  const selectEntidad = (idEstado) => {
    if (idEstado) {
      setEntidad(idEstado);
    } else {
      setEntidad(undefined);
    }
  };

  useEffect(() => {
    dispatch(obtenerEstado());
  }, [dispatch]);

  // useEffect(() => {
  //   if (vacanteDetalle.idCargoPuesto !== undefined) {
  //     setbtnpostula(false);
  //   } else {
  //     setbtnpostula(true);
  //   }
  // }, [vacanteDetalle.idCargoPuesto]);

  // useEffect(() => {
  //   if (vacanteDetalle.idTipoCargoPuesto !== undefined) {
  //     setbtnpostula(false);
  //   } else {
  //     setbtnpostula(true);
  //   }
  // }, [vacanteDetalle.idTipoCargoPuesto]);

  return (
    <>
      <div
        className={
          vacanteDetalle.nombreArea
            ? "mainContenidoVacantes"
            : "mainContenidoVacantesEmpty"
        }
      >
        <ModalExamen />

        {vacanteDetalle.nombreArea ? (
          <div>
            <div>
              <Row>
                <Col span={12}>
                  <Card className="card-vacantes-contenido">
                    <div className="title-card-vacantes">Denominación:</div>
                    <div className="text-card-vacantes">
                      {idSistema === 1 && <>{vacanteDetalle.nombretipoAlone}</>}
                      {idSistema === 2 && <>{vacanteDetalle.denominacion}</>}
                    </div>
                  </Card>
                </Col>
                <Col span={12}>
                  <Card className="card-vacantes-contenido">
                    <div className="title-card-vacantes">
                      Área de adscripción:
                    </div>
                    <div className="text-card-vacantes">
                      {vacanteDetalle.nombreArea}
                    </div>
                  </Card>
                </Col>
              </Row>
            </div>
            <div>
              <div className="contenido-vacantes-title">
                Descripción general del cargo
              </div>
              <div className="contenido-vacantes-subtitle">Objetivo:</div>
              <div
                className="contenido-vacante-text"
                style={{ margin: "10px 0px 20px 0px" }}
              >
                {idSistema === 1 && <>{objetivoINE.descripcionObjetivo}</>}
                {idSistema === 2 && <>{objetivos?.descripcionObjetivo}</>}
              </div>
              <div className="contenido-vacantes-subtitle">Funciones:</div>
              <div
                className="contenido-vacante-text"
                style={{ margin: "10px 0px 20px 0px" }}
              >
                <ul>
                  {idSistema === 1 && (
                    <>
                      {funcionesINE !== undefined &&
                        funcionesINE.map((item, index) => (
                          <li key={index}>
                            <p>{item.descripcionFuncion}</p>
                          </li>
                        ))}
                    </>
                  )}
                  {idSistema === 2 && (
                    <>
                      {funciones !== undefined &&
                        funciones.map((item, index) => (
                          <li key={index}>
                            <p>{item.descripcionFuncion}</p>
                          </li>
                        ))}
                    </>
                  )}
                </ul>
              </div>
              <div className="contenido-vacantes-subtitle">Requisitos:</div>
              <div
                className="contenido-vacante-text"
                style={{ margin: "10px 0px 20px 0px" }}
              >
                <ul>
                  {idSistema === 1 && (
                    <>
                      {
                        /*requisitosINE !== undefined &&
                        requisitosINE.map((item, index) => (
                          <div key={index}>
                            <li>
                              <p>
                                <b>Nivel de estudios:</b>{" "}
                                {item?.nombreNivelEstudio}
                              </p>
                            </li>
                            <li>
                              <p>
                                <b>Área de estudios:</b>{" "}
                                {item?.nombreAreaAcademica}
                              </p>
                            </li>
                            <li>
                              <p>
                                <b>Nombre carrera:</b> {item?.nombreCarrera}
                              </p>
                            </li>
                            <li>
                              <p>
                                <b>Estatus académico:</b>{" "}
                                {item?.nombreGradoAvance}
                              </p>
                            </li>
                            <li>
                              <p>
                                <b>Años de experiencia:</b>{" "}
                                {item?.tiempoExperiencia}{" "}
                                {item.tiempoExperiencia === "1"
                                  ? "año"
                                  : "años"}
                              </p>
                            </li>
                            <li>
                              <p>
                                <b>Acción afirmativa:</b> {item?.descripcion}
                              </p>
                            </li>
                          </div>
                        ))*/

                        requisitosINE !== undefined &&
                          requisitosINE.map((item, index) => (
                            <div key={index}>
                              <li>
                                <p>
                                  <b>Nivel de estudios:</b>{" "}
                                  {item?.nombreNivelEstudio}
                                </p>
                              </li>
                              {perfilesINE?.activoConfiguracion === 1 ? (
                                <li>
                                  <p>
                                    <b>
                                      Consulta los requerimientos de área
                                      académica y años de experiencia laboral,
                                      así como el perfil completo de la vacante,
                                      en la siguiente liga:
                                    </b>{" "}
                                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                    <a
                                      href={perfilesINE?.valorConfiguracion}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {" "}
                                      Perfiles de los cargos y puestos a
                                      concursar{" "}
                                    </a>
                                  </p>
                                </li>
                              ) : (
                                <li>
                                  <p>
                                    <b>
                                      Consulta los requerimientos de área
                                      académica y años de experiencia laboral,
                                      así como el perfil completo de la vacante,
                                      en la siguiente liga:
                                    </b>{" "}
                                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                    <Link to={linksRouter.cvacantes}>
                                      {" "}
                                      Perfiles de los cargos y puestos a
                                      concursar{" "}
                                    </Link>
                                  </p>
                                </li>
                              )}

                              <li>
                                <p>
                                  <b>Estatus académico:</b>{" "}
                                  {item?.nombreGradoAvance}
                                </p>
                              </li>
                              <li>
                                <p>
                                  <b>Acción afirmativa:</b> {item?.descripcion}
                                </p>
                              </li>
                            </div>
                          ))
                      }
                    </>
                  )}
                  {idSistema === 2 && (
                    <>
                      {requisitos !== undefined &&
                        requisitos.map((item, index) => (
                          <div key={index} style={{ textAlign: "justify" }}>
                            {/* <li>
                              <p>
                                <b>Nivel de estudios:</b>{" "}
                                {item?.nombreNivelEstudio}
                              </p>
                            </li>
                            <li>
                              <p>
                                <b>Área de estudios:</b>{" "}
                                {item?.nombreAreaAcademica}
                              </p>
                            </li>
                            <li>
                              <p>
                                <b>Nombre carrera:</b> {item?.nombreCarrera}
                              </p>
                            </li>
                            <li>
                              <p>
                                <b>Estatus académico:</b>{" "}
                                {item?.nombreGradoAvance}
                              </p>
                            </li>
                            <li>
                              <p>
                                <b>Años de experiencia:</b>{" "}
                                {item?.tiempoExperiencia}{" "}
                                {item.tiempoExperiencia === "1"
                                  ? "año"
                                  : "años"}
                              </p>
                            </li>
                            <li>
                              <p>
                                <b>Acción afirmativa:</b> {item?.descripcion}
                              </p>
                            </li> */}
                            <li>
                              <p>
                                <b>Nivel de estudios:</b>{" "}
                                {item?.nombreNivelEstudio}
                              </p>
                            </li>
                            {perfilesOPLE?.activoConfiguracion === 1 ? (
                              <li>
                                <p>
                                  <b>
                                    Consulta los requerimientos de área
                                    académica y años de experiencia laboral, así
                                    como el perfil completo de la vacante, en la
                                    siguiente liga:
                                  </b>{" "}
                                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                  <a
                                    href={perfilesOPLE?.valorConfiguracion}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    {" "}
                                    Perfiles de los cargos y puestos a concursar{" "}
                                  </a>
                                </p>
                              </li>
                            ) : (
                              <li>
                                <p>
                                  <b>
                                    Consulta los requerimientos de área
                                    académica y años de experiencia laboral, así
                                    como el perfil completo de la vacante, en la
                                    siguiente liga:
                                  </b>{" "}
                                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                  <Link to={linksRouter.cvacantes}>
                                    {" "}
                                    Perfiles de los cargos y puestos a concursar{" "}
                                  </Link>
                                </p>
                              </li>
                            )}

                            <li>
                              <p>
                                <b>Estatus académico:</b>{" "}
                                {item?.nombreGradoAvance}
                              </p>
                            </li>
                            <li>
                              <p>
                                <b>Acción afirmativa:</b> {item?.descripcion}
                              </p>
                            </li>
                          </div>
                        ))}
                    </>
                  )}
                </ul>
              </div>
              {autenticado && (
                <div>
                  <center>
                    <Button
                      className="contenido-vacante-btn-postula"
                      htmlType="submit"
                      onClick={validaProtesto}
                      disabled={
                        resultadoFinal[0]?.resultadoFinal === 0 ||
                        (btnbandera === 1 &&
                          Object.values(sistemaBand).includes(idSistema))
                      }
                    >
                      Postularme
                    </Button>
                    <ModalVacante />
                    <ModalImportante />
                  </center>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div style={{ height: "100%" }}>
            <Row
              justify="space-around"
              align="middle"
              style={{ height: "100%" }}
            >
              <Col span={24}>
                <Empty
                  description={
                    <span>
                      Seleccionar una opción para mostrar cargo/puesto
                    </span>
                  }
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                />
              </Col>
            </Row>
          </div>
        )}
      </div>
    </>
  );
};
